import { InvestorAppState } from 'store/types';

export function investorAppRootStateSelector(state: InvestorAppState) {
  return state.investor;
}
